// bazaar — am. Part of the am i18n bundle; merged by ./index.js

export default {
  bazaarTitle: 'ባዛር',
  bazaarSubtitle: 'ከሁሉም ሻጮች ምርቶችን በአንድ ቦታ ያስሱ',
  bazaarMarketplaceWord: 'ገበያ',
  bazaarClosedDesc: 'የAll Things ባዛር በአሁን ተዘግቷል። ከየትማል ሻጮች ምርቶችን ለማየትና ለመግዛት ይመለሱ።',
};

